
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...wordpressMortgageAgentsListFR]",
      function () {
        return require("private-next-pages/[...wordpressMortgageAgentsListFR].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...wordpressMortgageAgentsListFR]"])
      });
    }
  